import React from 'react';
import './PageShell.css';

const PageShell = ({
  eyebrow,
  title,
  subtitle,
  meta,
  actions,
  children,
  className = '',
}) => (
  <section className={`ui-page-shell ${className}`.trim()}>
    <div className="ui-page-shell-header">
      <div className="ui-page-shell-copy">
        {eyebrow && <span className="ui-page-shell-eyebrow">{eyebrow}</span>}
        <div className="ui-page-shell-title-row">
          <h1>{title}</h1>
          {meta && <div className="ui-page-shell-meta">{meta}</div>}
        </div>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="ui-page-shell-actions">{actions}</div>}
    </div>
    {children && <div className="ui-page-shell-content">{children}</div>}
  </section>
);

export default PageShell;
